// aliasing the global function for improved minification and
// protection against hasOwnProperty overrides.
export function addEventListener(target, eventType, callback) {
    if (target.addEventListener) {
        target.addEventListener(eventType, callback, false);
    }
    else if (target.attachEvent) {
        target.attachEvent("on" + eventType, callback);
    }
}
export function removeEventListener(target, eventType, callback) {
    if (target.removeEventListener) {
        target.removeEventListener(eventType, callback, false);
    }
    else if (target.detachEvent) {
        target.detachEvent("on" + eventType, callback);
    }
}
